/** @jsx jsx */
import { Button } from '@datacamp/waffles/button';
import { Checkmark, Cross } from '@datacamp/waffles/icon';
import { Paragraph } from '@datacamp/waffles/paragraph';
import { tokens } from '@datacamp/waffles/tokens';
import { jsx } from '@emotion/react';

type Props = {
  onRateClick: () => void;
};

const LearningRecapRating: React.FC<Props> = ({ onRateClick }) => {
  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flexGrow: 1,
        gap: tokens.spacing.small,
      }}
    >
      <Paragraph
        style={{
          margin: 0,
          fontSize: tokens.fontSizes.medium,
          fontWeight: tokens.fontWeights.bold,
        }}
      >
        Was this useful?
      </Paragraph>
      <div>
        <Button
          data-cy="learn-recap-positive-rate-button"
          aria-label="Yes"
          css={{
            border: 'none',
            fontSize: tokens.fontSizes.medium,
            fontWeight: tokens.fontWeights.regular,
          }}
          onClick={onRateClick}
          size="small"
        >
          <Checkmark />
          Yes
        </Button>
        <Button
          data-cy="learn-recap-negative-rate-button"
          aria-label="No"
          css={{
            border: 'none',
            fontSize: tokens.fontSizes.medium,
            fontWeight: tokens.fontWeights.regular,
          }}
          onClick={onRateClick}
          size="small"
        >
          <Cross color={tokens.colors.red} />
          No
        </Button>
      </div>
    </div>
  );
};

export default LearningRecapRating;
